import { ChangeDetectorRef, Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ProgressService } from 'shared-ui/providers/progress.service';

@Component({
  selector: 'shared-page-loader',
  templateUrl: './page-loader.component.html',
  styleUrls: ['./page-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PageLoaderComponent implements OnInit, OnDestroy {
  private progress = inject(ProgressService);
  private cd = inject(ChangeDetectorRef);

  loading = false;

  private $pageLoad: Subscription;

  ngOnInit(): void {
    this.$pageLoad = this.progress.pageLoad.subscribe(value => this.setLoading(value));
  }

  ngOnDestroy(): void {
    this.$pageLoad.unsubscribe();
  }

  setLoading(value: boolean) {
    this.loading = value;
    this.cd.detectChanges();
  }
}
